import { h, Component } from 'preact';
import { Text } from 'preact-i18n';

import cx from 'classnames';

import style from './style.less';
import { configure } from '../../../config';

import FullImageTextOverlayCard from '../../cards/full-image-text-overlay-card';
import SimpleGridCluster from '../simple-grid-cluster';
import CardHeader from '../../pieces/card-header';
import { fetchArticleList } from '../../../lib/data';
import { fetchFromDailyMotionPlaylist } from '../../../lib/dailymotion';

import { trackingProvider, TrackingProvider, DIMENSION } from '@cube/track';

/**
 * The main cluster used to display a category of information
 * Layout:
 * - half width card with text over image, 2 simple vert cards
 * - 1x6 simple vertical cards
*/
@configure([
	'singleCube.browseCategories'
])
@trackingProvider({
	[DIMENSION.componentpath]: 'RecommendedCluster'
})
export default class RecommendedCluster extends Component {

	state = {
		topLeftAsset: null,
		topRightAssets: [],
		bottomAssets: [],
		hasResults: false,
		rawTitle: ''
	};

	getAssets = (props) => {
		this.setState({
			error: false,
			title: props.titleOverride || <Text id={props.titleId || 'titleForMe'} fields={{ title: props.title }} />,
			rawTitle: props.titleOverride || props.title || ''
		});

		let vamCount = 0, dmCount = 0;

		if (props.dmPlaylist && props.dmLocation) {
			if (props.dmLocation.zone1) dmCount++; else vamCount++;
			if (props.dmLocation.zone2) dmCount+=2; else vamCount+=2;
			if (props.dmLocation.zone3) dmCount+=props.bottomRowCount; else vamCount+=props.bottomRowCount;

			fetchFromDailyMotionPlaylist({ limit: dmCount, ...props }).then( res => {
				if (res.articles && res.articles.length > 0) {
					let newState = { hasResults: true };

					if (props.dmLocation.zone1) {
						newState.topLeftAsset = res.articles[0];
					}
					if (props.dmLocation.zone2) {
						let start = (props.dmLocation.zone1 ? 1 : 0);
						newState.topRightAssets = res.articles.slice(start, start+2);
					}
					if (props.dmLocation.zone3) {
						let start = (props.dmLocation.zone1 ? 1 : 0) + (props.dmLocation.zone2 ? 2 : 0);
						newState.bottomAssets = res.articles.slice(start, start+props.bottomRowCount);
					}

					this.setState(newState);
				}
			});
		}
		else {
			// All filled by VAM
			vamCount = 3 + props.bottomRowCount;
			props.dmLocation = { zone1: false, zone2: false, zone3: false };
		}

		return fetchArticleList({
			count: vamCount,
			imageSizes: 'w=640,h=360|w=400,h=300|w=256,h=144',
			...props }
		)
			.then( res => {
				if (res.articles && res.articles.length > 0) {
					let newState = { hasResults: true };

					if (!props.dmLocation.zone1) {
						newState.topLeftAsset = res.articles[0];
					}
					if (!props.dmLocation.zone2) {
						let start = (!props.dmLocation.zone1 ? 1 : 0);
						newState.topRightAssets = res.articles.slice(start, start+2);
					}
					if (!props.dmLocation.zone3) {
						let start = (!props.dmLocation.zone1 ? 1 : 0) + (!props.dmLocation.zone2 ? 2 : 0);
						newState.bottomAssets = res.articles.slice(start, start+props.bottomRowCount);
					}

					this.setState(newState);
				}
			});
	};

	static defaultProps = {
		bottomRowCount: 6
	};

	componentWillMount() {
		this.getAssets(this.props);
	}

	render(
		{ theme, link, qeId, bottomRowCount, taboolaNewsroomTag, clusterClass, ...props },
		{ topLeftAsset, topRightAssets, bottomAssets, title, rawTitle }
	) {
		//remove title from props so sub clusters do not get it
		delete props.title;

		return (
			<div {...(taboolaNewsroomTag ? { 'data-tb-region': taboolaNewsroomTag } : {} )} class={cx(style.recommendedCluster, clusterClass)} qid={qeId}>
				<CardHeader title={title} link={link} qeId={qeId} />
				<TrackingProvider {...{ [DIMENSION.componentpath]: rawTitle.replace(/ /g, '') }}>
					<div class={style.cards}>
						<div class={style.topRow}>
							{
								topLeftAsset &&
								<TrackingProvider {...{ [DIMENSION.componentpath]: 'TopLeft', [DIMENSION.clickindex]: 1 }}>
									<FullImageTextOverlayCard
										theme={theme}
										asset={topLeftAsset}
										imageRole="w=640,h=360"
										qeId={qeId + '-topleft-0'}
										{...props}
									/>
								</TrackingProvider>
							}
							{
								topRightAssets.length === 2 &&
									<TrackingProvider {...{ [DIMENSION.componentpath]: 'TopRight' }}>
										<SimpleGridCluster
											assets={topRightAssets}
											imageRole="w=400,h=300"
											rowCount={1}
											columnCount={2}
											qeId={qeId + '-topright'}
											{...props}
										/>
									</TrackingProvider>
							}
						</div>
						{
							bottomAssets.length === bottomRowCount &&
								<div class={style.bottomRow}>
									<TrackingProvider {...{ [DIMENSION.componentpath]: 'Bottom' }}>
										<SimpleGridCluster
											assets={bottomAssets}
											imageRole="w=256,h=144"
											rowCount={1}
											columnCount={bottomRowCount}
											titleLines={3}
											qeId={qeId + '-bottom'}
											{...props}
										/>
									</TrackingProvider>
								</div>
						}
					</div>
				</TrackingProvider>
			</div>
		);
	}
}
